import { Button, CircularProgress, withStyles, WithStyles } from '@material-ui/core'
import { useState } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { stepForward } from '../../../actions/apartments'
import { allDefined, allValid } from '../../../utils/validation/general'

const styles = () => ({
  primaryBtn: {
    backgroundColor: '#94004A',
    '&:hover': {
      backgroundColor: '#670033'
    }
  }
})

interface NextStepButtonProps extends WithStyles, WithTranslation {
  doNextStep: any
  submit: boolean
  customLabel?: string
  disabled?: boolean
  beforeLogin?: boolean
  setIsEmpty?: any
  toValidate?: any
  toCheck?: any
}

const NextStepButton = ({
  classes,
  t,
  doNextStep,
  customLabel,
  submit,
  disabled,
  beforeLogin,
  setIsEmpty,
  toValidate,
  toCheck
}: NextStepButtonProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleClick = (arg: any, fields: any) => {
    if (allDefined(arg) && allValid(fields)) {
      setIsEmpty(false)
      setIsLoading(true)
      doNextStep(beforeLogin)
    } else setIsEmpty(true)
  }
  return (
    <Button
      fullWidth
      variant='contained'
      color='primary'
      className={classes.primaryBtn}
      style={{
        display: submit ? 'none' : 'flex',
        height: '42px',
        alignItems: 'center',
        position: 'relative'
      }}
      onClick={() => {
        handleClick(toValidate, toCheck)
      }}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <CircularProgress size={23} style={{ color: '#fff' }} />
      ) : (
        t(customLabel && submit ? customLabel : 'apartment.actions.nextStep')
      )}
    </Button>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  doNextStep: (beforeLogin: boolean) => dispatch(stepForward({ beforeLogin }))
})

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(NextStepButton))) as any
